import React, {useCallback} from 'react';
const useSettings = () => {
    return useCallback(function () {
        return window.storeLocatorSettings && typeof window.storeLocatorSettings !== "undefined" ?  window.storeLocatorSettings : false
    },[])();
}

export default useSettings